import CourseExamQuestionsSpec, {
  COURSE_EXAM_QUESTIONS_SPEC_TYPE,
  fromJS as courseExamQuestionsSpecFromJS
} from "./CourseExamQuestionsSpec";
import CourseSectionsSpec, {
  COURSE_SECTIONS_SPEC_TYPE,
  fromJS as courseSectionsSpecFromJS
} from "./CourseSectionsSpec";
import CourseUserSectionsSpec, {
  COURSE_USER_SECTIONS_SPEC_TYPE,
  fromJS as courseUserSectionsSpecFromJS
} from "./CourseUserSectionsSpec";

export const specsMap = Object.freeze({
  [COURSE_SECTIONS_SPEC_TYPE]: {
    Record: CourseSectionsSpec,
    fromJS: courseSectionsSpecFromJS
  },
  [COURSE_EXAM_QUESTIONS_SPEC_TYPE]: {
    Record: CourseExamQuestionsSpec,
    fromJS: courseExamQuestionsSpecFromJS
  },
  [COURSE_USER_SECTIONS_SPEC_TYPE]: {
    Record: CourseUserSectionsSpec,
    fromJS: courseUserSectionsSpecFromJS
  }
});

export const specTypes = Object.freeze({
  "course-sections": COURSE_SECTIONS_SPEC_TYPE,
  "course-exam-questions": COURSE_EXAM_QUESTIONS_SPEC_TYPE,
  "course-user-sections": COURSE_USER_SECTIONS_SPEC_TYPE
});

export type SpecTypeType = typeof specTypes[keyof typeof specTypes];
